<uni-page>
  <ng-container title>{{ 'page.403.title' | translate }}</ng-container>
  <ng-container error>{{ 'page.403.error' | translate }}</ng-container>
</uni-page>
